
  // @ts-ignore

import { ChainId, TokenAmount } from '@uniswap/sdk'
import React, { useState , useEffect } from 'react'
import { Text } from 'rebass'
import { NavLink } from 'react-router-dom'
import { darken } from 'polished'
import { useTranslation } from 'react-i18next'

import styled from 'styled-components'

import Logo from '../../assets/images/logo.png'
import coinLogo from '../../assets/images/coinLogo.png'
import LogoDark from '../../assets/images/logo.png'
import meta from '../../assets/svg/meta.svg'

import { useActiveWeb3React } from '../../hooks'
import { useDarkModeManager } from '../../state/user/hooks'
import { useETHBalances, useAggregateUniBalance } from '../../state/wallet/hooks'
import { CardNoise } from '../earn/styled'
import { CountUp } from 'use-count-up'
import { TYPE, ExternalLink } from '../../theme'

import { YellowCard } from '../Card'
import { Moon, Sun } from 'react-feather'


import Row, { RowFixed } from '../Row'
import Web3Status from '../Web3Status'
import ClaimModal from '../claim/ClaimModal'
import { useToggleSelfClaimModal, useShowClaimPopup } from '../../state/application/hooks'
import { useUserHasAvailableClaim } from '../../state/claim/hooks'
import { useUserHasSubmittedClaim } from '../../state/transactions/hooks'
import { Dots } from '../swap/styleds'
import Modal from '../Modal'
import UniBalanceContent from './UniBalanceContent'
import usePrevious from '../../hooks/usePrevious'

import useUSDCPrice from '../../utils/useUSDCPrice'

import useIsMobile from 'hooks/useIsMobile'



import { UNI } from '../../constants'

import { addCustomNetwork } from './addCustomNetwork'

const MenuButton = styled.button`


	padding: .25rem .75rem;
	font-size: 1.25rem;
	line-height: 1;
	background-color: transparent;

  border: 1px solid white;
  cursor: pointer;
 
  border-radius: .25rem;
  display: none;  // Default to not display

  ${({ theme }) => theme.mediaWidth.upToMedium`
    display: block;  // Display on small screens
  `};

  svg {
    fill: currentColor;  // Use the color property of the button to color the SVG
  }
`;

const HeaderFrame = styled.div`
  display: grid;
  grid-template-columns: 1fr 120px;
  align-items: center;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  width: 100%;
  top: 0;
  position: relative;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 1rem;
  z-index: 2;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    grid-template-columns: 1fr;
    padding: 0 1rem;
    width: calc(100%);
    position: relative;
  `};

  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
        padding: 0.5rem 1rem;
  `}
`

const HeaderControls = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-self: flex-end;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-direction: row;
    justify-content: space-between;
    justify-self: center;
    width: 100%;
    max-width: 960px;
    padding: 1rem;
    position: fixed;
    bottom: 0px;
    left: 0px;
    width: 100%;
    z-index: 99;
    height: 72px;
    border-radius: 12px 12px 0 0;
    background-color: ${({ theme }) => theme.bg1};
  `};
`

const HeaderElement = styled.div`
  display: flex;
  align-items: center;

  /* addresses safari's lack of support for "gap" */
  & > *:not(:first-child) {
    margin-left: 8px;
  }

  ${({ theme }) => theme.mediaWidth.upToMedium`
   flex-direction: row-reverse;
    align-items: center;
  `};
`

const HeaderElementWrap = styled.div`
  display: flex;
  align-items: center;
`

const HeaderRow = styled(RowFixed)`
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 100%;
  `};
`


const HeaderMobileRow = styled(RowFixed)`
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 100%;
  `};
`

const HeaderLinks = styled(Row)`
  justify-content: center;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    padding: 1rem 0 1rem 1rem;
    justify-content: flex-end;
`};

`


const MobileHeaderLinks = styled(Row)`
  justify-content: left;
  display:flex;
  text-align:left;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    padding: 1rem 0 1rem 1rem;
   
`};
`





const AccountElement = styled.div<{ active: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: transparent;

  white-space: nowrap;
  width: 100%;
  cursor: pointer;

  :focus {
    border: 1px solid blue;
  }
`



const UNIAmount = styled(AccountElement)`

  padding: 2px 8px;
  height: 37px;
  font-weight: 500;
  background-color: transparent;
  border:1px solid #18283d;
  border-radius: 0px;
  

  color:${({ theme }) => theme.text1}

  
  
`

const UNIWrapper = styled.span`
  width: fit-content;
  position: relative;
  cursor: pointer;

  :hover {
    opacity: 0.8;
  }

  :active {
    opacity: 0.9;
  }
`

const HideSmall = styled.span`
  ${({ theme }) => theme.mediaWidth.upToSmall`
    display: none;
  `};
`

const NetworkCard = styled(YellowCard)`
  border-radius: 12px;
  padding: 8px 12px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin: 0;
    margin-right: 0.5rem;
    width: initial;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 1;
  `};
`

const BalanceText = styled(Text)`
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    display: none;
  `};
`

const Title = styled.a`
  display: flex;
  align-items: center;
  pointer-events: auto;
  justify-self: flex-start;
  margin-right: 12px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    justify-self: center;
  `};
  :hover {
    cursor: pointer;
  }
`

const UniIcon = styled.div`
  transition: transform 0.3s ease;
  :hover {
    transform: rotate(-5deg);
  }
`

const activeClassName = 'ACTIVE'

const StyledNavLink = styled(NavLink).attrs({
  activeClassName
})`
  ${({ theme }) => theme.flexRowNoWrap}
  align-items: left;
  border-radius: 3rem;
  outline: none;
  cursor: pointer;
  text-decoration: none;
  color: ${({ theme }) => theme.text2};
  font-size: 1rem;
  width: fit-content;
  margin: 0 12px;
  font-weight: 500;

  &.${activeClassName} {
    border-radius: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.text1};
  }

  :hover,
  :focus {
    color: ${({ theme }) => darken(0.1, theme.text1)};
  }
`

const StyledExternalLink = styled(ExternalLink).attrs({
  activeClassName
})<{ isActive?: boolean }>`
  ${({ theme }) => theme.flexRowNoWrap}
  align-items: left;
  border-radius: 3rem;
  outline: none;
  cursor: pointer;
  text-decoration: none;
  color: ${({ theme }) => theme.text2};
  font-size: 1rem;
  width: fit-content;
  margin: 0 12px;
  font-weight: 500;

  &.${activeClassName} {
    border-radius: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.text1};
  }

  :hover,
  :focus {
    color: ${({ theme }) => darken(0.1, theme.text1)};
  }

  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
      display: none;
`}
`

export const StyledMenuButton = styled.button`
  position: relative;
  width: 100%;
  height: 100%;
  border: none;
  background-color: transparent;
  margin: 0;
  padding: 0;
  height: 35px;
  background-color: ${({ theme }) => theme.bg3};
  margin-left: 8px;
  padding: 0.15rem 0.5rem;
  border-radius: 0.5rem;

  :hover,
  :focus {
    cursor: pointer;
    outline: none;
    
  }

  svg {
    margin-top: 2px;
  }
  > * {
    stroke: ${({ theme }) => theme.text1};
  }
`





const NETWORK_LABELS: { [chainId in ChainId]?: string } = {
  [ChainId.RINKEBY]: 'Rinkeby',
  [ChainId.ROPSTEN]: 'Ropsten',
  [ChainId.GÖRLI]: 'Görli',
  [ChainId.KOVAN]: 'Kovan'
}

export default function Header() {

  const isMobile = useIsMobile();

  const [isMenuOpen, setMenuOpen] = useState(false);


  const SvgIcon = () => (
    <svg viewBox="0 0 24 24"  width="30px" xmlns="http://www.w3.org/2000/svg" color="black" >
      <path d="M4 18H20C20.55 18 21 17.55 21 17C21 16.45 20.55 16 20 16H4C3.45 16 3 16.45 3 17C3 17.55 3.45 18 4 18ZM4 13H20C20.55 13 21 12.55 21 12C21 11.45 20.55 11 20 11H4C3.45 11 3 11.45 3 12C3 12.55 3.45 13 4 13ZM3 7C3 7.55 3.45 8 4 8H20C20.55 8 21 7.55 21 7C21 6.45 20.55 6 20 6H4C3.45 6 3 6.45 3 7Z"></path>
    </svg>
  );



  const { account, chainId ,library} = useActiveWeb3React()
  const { t } = useTranslation()

  const uni = chainId ? UNI[chainId] : undefined





  const addNetwork = () => {
    // Alert with the button name and add network
    alert('Add Network  clicked!')
    // Add network implementation here
    console.log("helllllllllllllll")
    console.log(chainId)
    console.log(library)
  }


  useUSDCPrice(uni);

  // const nativeCurrecyInUsd = "0.001"
  const [usdPrice,setUsdPrice]= useState("0")
  



  const userEthBalance = useETHBalances(account ? [account] : [])?.[account ?? '']
  // const [isDark] = useDarkModeManager()
  const [darkMode, toggleDarkMode] = useDarkModeManager()

  const toggleClaimModal = useToggleSelfClaimModal()

  const availableClaim: boolean = useUserHasAvailableClaim(account)

  const { claimTxn } = useUserHasSubmittedClaim(account ?? undefined)

  const aggregateBalance: TokenAmount | undefined = useAggregateUniBalance()

  const [showUniBalanceModal, setShowUniBalanceModal] = useState(false)
  const showClaimPopup = useShowClaimPopup()

  const countUpValue = aggregateBalance?.toFixed(0) ?? '0'
  const countUpValuePrevious = usePrevious(countUpValue) ?? '0'

  return (
    <HeaderFrame>
      <ClaimModal />
      <Modal isOpen={showUniBalanceModal} onDismiss={() => setShowUniBalanceModal(false)}>
        <UniBalanceContent setShowUniBalanceModal={setShowUniBalanceModal} />
      </Modal>


      <HeaderRow  >
        <Title href=".">
          <UniIcon>
            <img width={'90px'}  src={darkMode ? LogoDark : Logo} alt="logo" />
          </UniIcon>
        </Title>

      { !isMobile ? (


        <HeaderLinks>


            <StyledNavLink id={`swap-nav-link`} to={'/swap'}>
                {t('swap')}
            </StyledNavLink>
            <StyledNavLink  id={`pool-nav-link`} to={'/pool'}
                isActive={(match, { pathname }) => Boolean(match) ||
                  pathname.startsWith('/add') ||
                  pathname.startsWith('/remove') ||
                  pathname.startsWith('/create') ||
                  pathname.startsWith('/find')
                }>{t('pool')}
            </StyledNavLink>

            <StyledExternalLink id={`stake-nav-link`} href={'https://hotcurves.fun'}>
                      hotcurves.fun <span style={{ fontSize: '11px' }}>↗</span>
            </StyledExternalLink>

            <StyledExternalLink id={`stake-nav-link`} href={'https://t.me/HotKeySwap'}>
                      Get in touch <span style={{ fontSize: '11px' }}>↗</span>
            </StyledExternalLink>
        </HeaderLinks>

      ):(

          <HeaderLinks>

            <MenuButton onClick={() => setMenuOpen(!isMenuOpen)}>
              <SvgIcon />
            </MenuButton>

          </HeaderLinks>

      )
      
      
      
      }



      </HeaderRow>

      {isMenuOpen && isMobile && (

      <HeaderMobileRow>

            <MobileHeaderLinks align='left'>


            <StyledNavLink id={`swap-nav-link`} to={'/swap'}>
                {t('swap')}
            </StyledNavLink>
            <StyledNavLink  id={`pool-nav-link`} to={'/pool'}
                isActive={(match, { pathname }) => Boolean(match) ||
                  pathname.startsWith('/add') ||
                  pathname.startsWith('/remove') ||
                  pathname.startsWith('/create') ||
                  pathname.startsWith('/find')
                }>{t('pool')}
            </StyledNavLink>

            <StyledExternalLink id={`stake-nav-link`} href={'https://hotcurves.fun'}>
                      hotcurves.fun <span style={{ fontSize: '11px' }}>↗</span>
            </StyledExternalLink>

            <StyledExternalLink id={`stake-nav-link`} href={'https://t.me/HotKeySwap'}>
                      Get in touch <span style={{ fontSize: '11px' }}>↗</span>
            </StyledExternalLink>


        
            </MobileHeaderLinks>

      </HeaderMobileRow>

    )}

     
      <HeaderControls>
        <HeaderElement>
          <HideSmall>
            {chainId && NETWORK_LABELS[chainId] && (
              <NetworkCard title={NETWORK_LABELS[chainId]}>{NETWORK_LABELS[chainId]}</NetworkCard>
            )}
          </HideSmall>
          {availableClaim && !showClaimPopup && (
            <UNIWrapper onClick={toggleClaimModal}>
              <UNIAmount active={!!account && !availableClaim} style={{ pointerEvents: 'auto' }}>
                <TYPE.white padding="0 2px">
                  {claimTxn && !claimTxn?.receipt ? <Dots>Claiming UNI</Dots> : 'Claim UNI'}
                </TYPE.white>
              </UNIAmount>
              <CardNoise />
            </UNIWrapper>
          )}
          {!availableClaim && aggregateBalance && (
            <UNIWrapper onClick={() => setShowUniBalanceModal(true)}>
              <UNIAmount active={!!account && !availableClaim} style={{ pointerEvents: 'auto' , display:'none' }}>
                {account && (
                  <HideSmall>
                    <TYPE.white
                      style={{
                        paddingRight: '.4rem'
                      }}
                    >
                      <CountUp
                        key={countUpValue}
                        isCounting
                        start={parseFloat(countUpValuePrevious)}
                        end={parseFloat(countUpValue)}
                        thousandsSeparator={','}
                        duration={1}
                      />
                    </TYPE.white>
                  </HideSmall>
                )}
                UNI
              </UNIAmount>
              <CardNoise />
            </UNIWrapper>
          )}



{/*          <UNIAmount active={!account}>

          <UniIcon>
            <img width={'25px'} style={{borderRadius:'50px',paddingRight:'3px'}}  src={coinLogo} alt="logo" />

          </UniIcon>
                  ${usdPrice}
           </UNIAmount>

*/}
       
            <UNIAmount active={false} style={{border: '1px solid #18283d',borderRadius: '0px!important'}} >

          <UniIcon>
            <img width={'16px'} style={{marginLeft:"4px;",marginTop:"4px",paddingRight:'0px'}}  src={meta} alt="logo" />

          </UniIcon>

          <StyledMenuButton style={{ color: "#18283d",background:"transparent", fontSize:"1rem", margin:"0px"}} onClick={addCustomNetwork}>
          Add Network
        </StyledMenuButton>

            </UNIAmount>

          <AccountElement active={!!account} style={{ pointerEvents: 'auto' }}>
            {account && userEthBalance ? (
              <BalanceText style={{ flexShrink: 0 }} pl="0.75rem" pr="0.5rem" fontWeight={500}>
              
                {userEthBalance?.toSignificant(4)} {process.env.REACT_APP_COIN_SYMBOL}
              </BalanceText>
            ) : null}
            <Web3Status />
          </AccountElement>
        </HeaderElement>
        <HeaderElementWrap>

          

         
        </HeaderElementWrap>
      </HeaderControls>
    </HeaderFrame>
  )
}
